import { Link } from "react-router-dom";
import help from "../../assets/icons/ilohelp.svg";
import bell from "../../assets/icons/ilobell.svg";
import avtar from "../../assets/icons/iloavatar.svg";
import dots from "../../assets/icons/ilodots.svg";
import Subscription from "../../assets/icons/Subscription.svg";
import { useAccount } from '../context/AccountProvider';
import React, { useState, useRef, useEffect, use } from "react";
import digisign from "../../assets/icons/digisign.svg";
import dealbase from "../../assets/icons/dealbase.svg";
import casebase from "../../assets/icons/casebase.svg";
import lawbase from "../../assets/icons/lawbase.svg";
import openbase from "../../assets/icons/openbase.svg";
import kronicle from "../../assets/icons/kronicle.svg";
import kronai from "../../assets/icons/kronai.svg";
import { useNavigate } from "react-router-dom";
import { getMyDetails } from "../../service/myDeatils";
import "./Header.scss";

function Header() {
  const { logout, isLoggedIn, userDetails, setUserDetails, userData, handleLogin, handleSignup } = useAccount();
  const [openDropdown, setOpenDropdown] = useState(false)
  const [otherAppsOpen, setOtherAppsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const dropdownRef = useRef(null);
  const otherAppsRef = useRef(null);

  console.log('isLoggedIn in header', userData);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        otherAppsRef.current &&
        !otherAppsRef.current.contains(event.target)
      ) {
        setOtherAppsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        return; // Don't check API or trigger auto-logout when not logged in
      }

      try {
        const response = await getMyDetails();

        // If user details are valid
        if (response && response.id) {
          localStorage.setItem("user_id", response.id);
          if (typeof setUserDetails === "function") {
            setUserDetails(response);
          }
        } else {
          console.warn("No valid user details — clearing local session.");
          logout(false);
        }
      } catch (err) {
        console.error("Error checking login status:", err);

        // Check if error indicates token expiry or unauthorized
        if (err.response?.status === 401 || err.message?.includes("401")) {
          console.warn("Token expired — clearing local session.");
          logout(false);
        }
      }
    };

    // Call immediately
    checkLoginStatus();

    // Schedule every 10 seconds
    const interval = setInterval(checkLoginStatus, 10000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const user = (userDetails && (userDetails.first_name || userDetails.email)) ? userDetails : (userData || {});
  const firstName = user?.first_name || user?.given_name || "";
  const lastName = user?.last_name || user?.family_name || "";
  const email = user?.email || "";

  let userInitials = "";
  if (firstName && lastName) {
    userInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  } else if (firstName) {
    userInitials = firstName.substring(0, 2).toUpperCase();
  } else if (email) {
    userInitials = email.charAt(0).toUpperCase();
  }

  return (
    <header className="ilo-header">
      <Link to="/" className="ilo-header-left" style={{ textDecoration: 'none', cursor: 'pointer' }}>
        <img src="/favicon.svg?v=v2" alt="India Law Online Logo" style={{ height: "34px", width: "34px", marginRight: "12px", borderRadius: "8px" }} />
        <span>India Law Online</span>
      </Link>
      {/* <div className="header-center">
        <Link to="/" style={{ marginRight: "15px" }}>Judgments</Link>
        <Link to="/about" style={{ marginRight: "15px" }}>Legislations</Link>
        <Link to="/contact">Contracts</Link>
      </div> */}

      {!isLoggedIn ? (
        <div className="ilo-header-right">
          <span
            onClick={handleSignup}
            className="ilo-header-right-button-signup"
            style={{ cursor: "pointer" }}
          >
            Sign Up
          </span>
          <span
            onClick={handleLogin}
            className="ilo-header-right-button-login"
            style={{ cursor: "pointer" }}
          >
            Login
          </span>
        </div>
      ) : (
        <div className="ilo-header-right">
          <span className="ilo-header-right-plans"><img src={help} alt="Help" /></span>
          <span className="ilo-header-right-signup"><img src={bell} alt="Notifications" /></span>
          <div style={{ position: "relative" }}>
            <div className="ilo-header-right-avatar" role="button" onClick={() => setOpenDropdown((prev) => !prev)}>
              {userInitials}
            </div>
            {openDropdown && (
              <div ref={dropdownRef} className="ilo-header-avtar-dropdown">
                <span className="ilo-header-avtar-dropdown-top">
                  <span className="ilo-header-right-avatar ilo-header-avtar-dropdown-top-left">
                    {userInitials}
                  </span>
                  <span className="ilo-header-avtar-dropdown-top-right">
                    <span className="ilo-header-avtar-dropdown-top-right-name">
                      {firstName} {lastName}
                    </span>
                    <span className="ilo-header-avtar-dropdown-top-right-email">{email}</span>
                  </span>
                </span>
                <span onClick={() => { navigate("/subscription"); setOpenDropdown(false); }} className="ilo-header-avtar-dropdown-middle">
                  <span style={{ display: "flex", padding: "0px 10px", alignItems: "center" }}>
                    <img src={Subscription} alt="Subscription" />
                    <span className="ilo-header-avtar-dropdown-middle-item">Subscription</span>
                  </span>
                </span>
                <span className="ilo-header-avtar-dropdown-bottom">
                  <div onClick={() => logout(true)} className="ilo-header-avtar-dropdown-bottom-item">
                    Logout
                  </div>
                </span>
              </div>
            )}
          </div>
          <div style={{ position: "relative" }} ref={otherAppsRef}>
            <span
              onClick={() => setOtherAppsOpen((prev) => !prev)}
              className="ilo-header-right-signup"
              style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              <img src={dots} alt="More Options" />
            </span>
            {otherAppsOpen && (
              <div
                className="ilo-header-apps-dropdown"
              >
                <div className="ilo-header-apps-dropdown-row-one">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev.digiesign.in/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={digisign} alt="DigieSign" />
                    DigieSign
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev-dealbase.lexops.co/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={dealbase} alt="DealBase" />
                    DealBase
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev-casebase.kronicle.in/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={casebase} alt="CaseBase" />
                    CaseBase
                  </a>
                </div>
                <div className="ilo-header-apps-dropdown-row-two">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev-lawbase.kronicle.in/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={lawbase} alt="LawBase" />
                    LawBase
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev-admin.lexops.co/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={openbase} alt="OpsBase" />
                    OpsBase
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://dev-admin.lexops.co/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={kronicle} alt="Kronicle 1" />
                    Kronicle 1
                  </a>
                </div>
                <div className="ilo-header-apps-dropdown-row-three">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://clm.kronai.com/"
                    className="ilo-header-apps-dropdown-icon"
                  >
                    <img src={kronai} alt="Kron AI CLM" />
                    Kron AI CLM
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;